import { Roles } from "../../../constants/roles";
import { FormBase } from "../../form-base-form";

export class VideoForm extends FormBase {
    public getContainer(postKey: string, root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.VIDEO_MANAGER}"][data-post-id="${postKey}"]`, HTMLElement);
    }

    public getFileInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[type="file"]');
    }

    public getRemovedAttachedVideosInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[name="removed_attached_videos"]');
    }

    public getAddButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.BTN_ADD_VIDEOS}"]`);
    }

    public getVideoGrid(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.VIDEO_GRID}"]`, HTMLElement);
    }

    public getTileRemoveButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.MEDIA_REMOVE}"]`);
    }

    public getEventTarget(event: Event): HTMLElement | null {
        return this.fromEventTarget(event, HTMLElement);
    }

    public getClosestRemoveButton(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, `[data-role="${Roles.MEDIA_REMOVE}"]`, HTMLElement);
    }

    public getExistingVideoTile(element: Element | null | undefined): HTMLElement | null {
        return this.closest(element, `[data-item-role="${Roles.EXISTING_VIDEO_TILE}"]`, HTMLElement);
    }

    public getRemovedIndicator(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.MEDIA_REMOVED_INDICATOR}"]`, HTMLElement);
    }

    public getMediaControls(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.MEDIA_CONTROLS}"]`, HTMLElement);
    }
}

export const videoForm = new VideoForm();
